module.exports = __webpack_public_path__ + "img/wechat-icon.4718b976.svg";